export default `
  query listPendingInvites {
    listPendingInvites {
      userId
      email
      firstname
      lastname
      createdAt
    }
  }
`
